<template>
  <div>
    <item-list
      :enable.sync="itemList"
      :items="items"
      :selectedItem.sync="selectedItem"
    ></item-list>

    <v-content class="home">
      <top-bar
        enable-search
        :search.sync="search"
        :itemList.sync="itemList"
        :line.sync="line"
        :viewType="viewType"
        @view="changeView"
      ></top-bar>

      <KitchenLineOptions v-if="!lineRestricted" />
      <v-card flat class="check-container home-container">
        <welcome v-if="!checks.length && viewType !== 'notifications'" />
        <div
          class="scroll-action-container"
          v-if="viewType === 'grid' && showScrollControls"
        >
          <v-btn
            large
            icon
            class="scroll-arrow ma-1"
            :disabled="!enableUpArrow"
            @click="moveTo(-scrollVal)"
            style="background-color: #1976d2"
            ><v-icon color="white" large>keyboard_arrow_up</v-icon></v-btn
          >
          <v-btn
            icon
            large
            class="scroll-arrow ma-1"
            :disabled="!enableDownArrow"
            @click="moveTo(scrollVal)"
            ><v-icon large color="white">keyboard_arrow_down</v-icon></v-btn
          >
        </div>

        <v-container
          ref="tickets_cont"
          fluid
          grid-list-md
          :px-1="mobile"
          class="tickets custom-scroll pa-2"
          :class="{ 'custom-scroll--lg': settings.increaseScrollWidth }"
          v-if="checks.length && viewType !== 'notifications'"
        >
          <v-layout row wrap v-if="viewType === 'grid'">
            <template v-for="check in filteredChecks">
              <v-flex
                d-flex
                :key="check.key"
                :sm4="!itemList"
                :sm6="itemList"
                :md3="!itemList"
                :md4="itemList"
                :xl2="!itemList"
                :xl3="itemList"
                v-if="check.enable"
              >
                <check
                  :check="check"
                  :search="search"
                  :selectedItem="selectedItem"
                ></check>
              </v-flex>
            </template>
          </v-layout>

          <v-layout row wrap v-if="viewType === 'list'">
            <item-view
              :checks="filteredChecks"
              :summaryView="itemList"
              :search="search"
              :selectedItem="selectedItem"
            ></item-view>
          </v-layout>

          <v-layout row wrap v-if="viewType === 'bump-out'">
            <bump-out-items :filtered-items="finishedItems"></bump-out-items>
          </v-layout>
          <v-layout row wrap v-if="viewType === 'summary'">
            <summary-view :items="summaryItems" @selectedItemInSummary="selectedItemInSummary"  ></summary-view>
          </v-layout>
          <div style="height: 40px"></div>
        </v-container>
        <notifications v-if="viewType === 'notifications'" />
      </v-card>
    </v-content>
  </div>
</template>

<style >
.home {
  background-color: #f5f5f5;
}
.home-container {
  min-height: 100vh;
  overflow: auto;
}

.theme--light .check-container {
  background-color: #fafafa;
}
.theme--dark .check-container {
  background-color: #212121;
}

.theme--dark .home {
  background-color: #212121;
}

.theme--dark.v-label {
  color: #fff;
}

html {
  overflow-y: auto;
}

@media screen and (min-width: 625px) {
  .tickets {
    height: calc(100vh - 50px);
    overflow-y: auto;
  }
}

/* scroll bar starts */

.custom-scroll::-webkit-scrollbar {
  width: 5px;
}

.custom-scroll.custom-scroll--lg::-webkit-scrollbar {
  width: 20px;
}

.custom-scroll::-webkit-scrollbar-thumb {
  background: #b4b3c7;
}

.custom-scroll::-webkit-scrollbar-thumb:hover {
  background: grey;
}

.scroll-arrow {
  background-color: #1976d2 !important;
}

.scroll-arrow:disabled {
  background-color: #1976d2 !important;
  opacity: 0.8;
}

.scroll-action-container {
  height: 50px;

  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;

  position: absolute;
  bottom: 0px;
  right: 60px;

  bottom: 1px solid #000;
  background-color: transparent;

  z-index: 999;
}
</style>


<script>
import welcome from "@/components/welcome";
import topBar from "@/components/topbar";
import check from "@/components/checkView/check";
import itemList from "@/components/summary/items";
import Mixin from "@/components/utils/mixin";
import itemView from "@/components/itemView/home";
import BumpOutItems from "@/components/itemView/BumpOutItems";
import Notifications from "@/components/notifications/Notifications";
import KitchenLineOptions from "./KLine";
import summaryView from "./summaryNew/summary.vue";

export default {
  name: "home",
  mixins: [Mixin],
  components: {
    welcome,
    topBar,
    check,
    "item-list": itemList,
    itemView,
    BumpOutItems,
    Notifications,
    KitchenLineOptions,
    summaryView
  },
  data() {
    return {
      search: {
        txt: "",
        selectedServiceTypes: [],
        selectedStatus: [],
        selectedItemStatus: [2, 3],
        checkSortOrder: "1",
        sortOrder: "1",
        sortBy: "1",
        sortBy: "1",
        splitByKotNo: false
      },
      tickets: {},
      itemList: true,
      line: {},
      selectedItem: 0,
      timerId: null,
      viewType: "grid",
      enableUpArrow: false,
      enableDownArrow: true,
      scrollVal: 200,
      showScrollBtn: false,
      lineRestricted: JSON.parse(localStorage.getItem("isLineRestricted"))
    };
  },
  methods: {
    selectedItemInSummary(id) {
      this.changeView("grid");
      this.selectedItem = id;
    },
    changeView(view) {
      this.viewType = view;
      if (
        view === "bump-out" ||
        view === "notifications" ||
        view === "summary"
      ) {
        this.itemList = false;
        // this.selectedItem = null;
      } else {
        this.itemList = true;
      }
    },
    checkFilter(txt, arr) {
      let res = arr.find((item) => {
        return `${item}`.toLowerCase().includes(txt.toLowerCase());
      });
      if (res) {
        return true;
      }
    },
    onScroll(evt) {
      let elem = this.$refs.tickets_cont;
      if (elem) {
        this.showScrollBtn = elem.scrollHeight > elem.clientHeight;
        this.enableUpArrow = elem.scrollTop > 0;
        this.enableDownArrow =
          elem.scrollHeight > elem.scrollTop + elem.clientHeight;
      }
    },
    moveTo(px) {
      this.$nextTick(() => {
        let elem = this.$refs.tickets_cont;
        if (elem) {
          if (px > 0) {
            elem.scrollTop += px;
          } else {
            if (
              elem.scrollTop > this.scrollVal &&
              elem.scrollTop < this.scrollVal
            ) {
              elem.scrollTop = 0;
              return;
            }
            elem.scrollTop += px;
          }
        }
      });
    },
    addScrollListener() {
      this.$nextTick(() => {
        let elem = this.$refs.tickets_cont;
        if (elem) {
          this.showScrollBtn = elem.scrollHeight > elem.clientHeight;
          elem.addEventListener("scroll", this.onScroll);
        }
      });
    },
    initPreference() {
      this.search.selectedServiceTypes = this.preference.serviceTypes;
      this.search.selectedStatus = this.preference.statusTypes;
      this.search.selectedItemStatus = this.preference.itemStatus;
      this.search.checkSortOrder = this.preference.checkSortOrder;
      this.search.sortOrder = this.preference.sortOrder;
      this.search.sortBy = this.preference.sortBy;
      this.search.splitByKotNo = this.preference.splitByKotNo;
    },
    groupBy(items, key) {
      if (!items || !key) return items;
      const itemByKey = {};

      items.forEach((item) => {
        const keyVal = item[key] || 0;
        if (!itemByKey[keyVal]) {
          itemByKey[keyVal] = [];
        }
        itemByKey[keyVal].push(item);
      });

      return itemByKey;
    },
    splitChecksByKotNo(tickets) {
      let splitChecks = [];

      tickets.forEach((fc) => {
        const groupedItems = this.groupBy(fc.items, "kot_number");
        // const groupedItems = Object.groupBy(fc.items, (e) => e.kot_number);
        let newCheck = JSON.parse(JSON.stringify(fc));
        newCheck.items = [];

        for (const key in groupedItems) {
          let splitCheck = JSON.parse(JSON.stringify(newCheck));
          splitCheck.items = groupedItems[key];

          const sortedItems = splitCheck.items.sort((a, b) => {
            const d1 = a.status;
            const d2 = b.status;
            if (d1 < d2) return -1;
            if (d1 > d2) return 1;
            return 0;
          });

          splitCheck.status = sortedItems[0].status;
          splitCheck.color = sortedItems[0].color;

          splitCheck.key = splitCheck.ticket_name + "_" + key;
          splitCheck.kot_number = Number(key);

          splitCheck.ordinal = splitCheck.kot_number;
          const sortBy = this.search.sortBy;
          if (sortBy === "2") {
            splitCheck.ordinal = Number(fc.check_number);
          }

          splitChecks.push(splitCheck);
        }
      });

      return splitChecks;
    },
    getTicketOrdinal(check) {
      const sortBy = this.search.sortBy;
      if (sortBy === "2") {
        return Number(check.check_number);
      }

      const checkSort = Number(this.search.checkSortOrder);
      let results = check.items
        .filter((item) => item.status != 4)
        .sort((a, b) => {
          // let d1 = Number(a.kot_sent_time.replace(/\D/g, ""));
          // let d2 = Number(b.kot_sent_time.replace(/\D/g, ""));
          const d1 = a.kot_number;
          const d2 = b.kot_number;
          if (d1 < d2) return checkSort * -1;
          if (d1 > d2) return checkSort;
          return 0;
        });

      return results.length
        ? // ? Number(results[0].kot_sent_time.replace(/\D/g, ""))
          Number(results[0].kot_number)
        : 0;
    },

    splitInstructions(arr) {
      return arr.flatMap((i) => i.split(",")) || [];
    },
    formatInstructions(arr) {
      return [...arr].map((i) => i.trim().toLowerCase()).sort();
    },
    isSameInstructions(arr1, arr2) {
      const sorted1 = this.formatInstructions(arr1);
      const sorted2 = this.formatInstructions(arr2);
      const result = sorted1.every((val) => sorted2.includes(val));
      return result;
    },
    addModifiersInItemSplit(
      arr,
      modifiers,
      instructions,
      quantity,
      serviceType
    ) {
      const service = this.getServiceInfo(serviceType, quantity);
      let editedModifiers = modifiers.reduce(
        (acc, m) => {
          acc.modifierIds.push(m.id);
          acc.modifiers.push(m.name);
          return acc;
        },
        {
          modifierIds: [],
          modifiers: [],
          instructions: [...instructions],
          quantity: quantity,
          services: service ? [service] : []
        }
      );

      arr.push(editedModifiers);
    },
    addInstructionsInItemSplit(arr, instructions, quantity, serviceType) {
      const service = this.getServiceInfo(serviceType, quantity);
      let editedInstructions = instructions.reduce(
        (acc, ins) => {
          acc.instructions.push(ins);
          return acc;
        },
        {
          modifierIds: [],
          instructions: [],
          quantity: quantity,
          services: service ? [service] : []
        }
      );

      arr.push(editedInstructions);
    },
    updateSplitServiceType(split, serviceType, quantity) {
      const service = this.getServiceInfo(serviceType, quantity);
      if (!service) return;

      const existing = split.services.find((s) => s.name === service.name);

      if (existing) {
        existing.quantity += quantity;
      } else {
        split.services.push(service);
      }
    },
    getServiceInfo(serviceType, quantity) {
      const serviceTypes = {
        1: { name: "qsr", icon: "flaticon-qsr", color: "red" },
        2: { name: "takeAway", icon: "flaticon-take-away", color: "green" },
        3: { name: "table", icon: "flaticon-dining-table", color: "primary" },
        4: {
          name: "delivery",
          icon: "flaticon-delivery-scooter-1",
          color: "error"
        },
        5: { name: "bar", icon: "flaticon-bar-service", color: "primary" },
        6: { name: "party", icon: "flaticon-juice", color: "primary" }
      };
      const service = serviceTypes[serviceType];
      return service
        ? {
            name: service.name,
            quantity,
            icon: service.icon,
            color: service.color
          }
        : null;
    }
  },
  computed: {
    checks() {
      let tickets = this.$store.getters.tickets;
      var checks = Object.keys(tickets)
        .map((i) => tickets[i])
        .filter((ticket) => {
          let filterTxt = [ticket.table_name, ticket.check_number];
          let valid =
            !this.search ||
            ((!this.search.selectedSaleTypes ||
              !this.search.selectedSaleTypes.length ||
              this.search.selectedSaleTypes.indexOf(ticket.sale_type) > -1) &&
              (!this.search.selectedServiceTypes ||
                !this.search.selectedServiceTypes.length ||
                this.search.selectedServiceTypes.indexOf(ticket.service_type) >
                  -1) &&
              (!this.search.txt ||
                this.checkFilter(this.search.txt, filterTxt)));
          ticket.enable = true;
          ticket.key = ticket.ticket_name;
          return valid;
        });

      if (this.search.splitByKotNo) {
        checks = this.splitChecksByKotNo(checks);
      }

      return checks; // unsorted checks
    },
    filteredChecks() {
      let checks = JSON.parse(JSON.stringify(this.checks));
      const checkSort = Number(this.search.checkSortOrder);
      return checks
        .map((check) => {
          let filtered = check.items.filter((item) => {
            return (
              !this.search ||
              !this.search.selectedItemStatus ||
              !this.search.selectedItemStatus.length ||
              this.search.selectedItemStatus.includes(item.status)
            );
          });

          if (this.selectedItem) {
            filtered = filtered.filter((item) => {
              if (this.selectedItem && this.selectedItem == item.menu_id)
                return true;

              return false;
            });
          }

          check.items = filtered;

          check.ordinal = this.getTicketOrdinal(check);

          return check;
        })
        .filter((c) => c.items.length)
        .sort((a, b) => {
          let d1 = a.ordinal;
          let d2 = b.ordinal;
          if (d1 < d2) return checkSort * -1;
          if (d1 > d2) return checkSort;
          return 0;
        });
    },
    summaryItems() {
      let result = {};
      let selectedItemAvailable = false;
      this.checks.forEach((check) => {
        check.items.forEach((item) => {
          if (item.status == 4 || item.status == 6 || item.status == 9) {
            return;
          }
          const key = "" + item.menu_id + "-" + item.serving_size_id;
          const modifiers = this.selectedModifiers(item.modifier_receipe) || [];
          let instructions = this.splitInstructions(item.instructions);

          instructions = this.formatInstructions(instructions);

          if (result.hasOwnProperty(key)) {
            result[key].qty += item.quantity;
            if (item.status == 3) {
              result[key].acceptedQty += item.quantity;
            }

            const currentService = this.getServiceInfo(
              check.service_type,
              item.quantity
            );
            const existingService = result[key].services.find(
              (s) => s.name === currentService.name
            );
            if (existingService) {
              existingService.quantity += item.quantity;
            } else {
              result[key].services.push({
                name: currentService.name,
                quantity: item.quantity,
                icon: currentService.icon,
                color: currentService.color
              });
            }

            const prevSplits = result[key].split;
            if (modifiers.length) {
              const modifierIds = modifiers.map((i) => i.id);
              const index = prevSplits.findIndex((m) => {
                const prevInstructions = this.splitInstructions(m.instructions);
                return (
                  m.modifierIds.length == modifierIds.length &&
                  prevInstructions.length == instructions.length &&
                  modifierIds.every((i) => m.modifierIds.includes(i)) &&
                  this.isSameInstructions(instructions, prevInstructions)
                );
              });
              if (index != -1) {
                prevSplits[index].quantity += item.quantity;
                this.updateSplitServiceType(
                  prevSplits[index],
                  check.service_type,
                  item.quantity
                );
              } else {
                this.addModifiersInItemSplit(
                  prevSplits,
                  modifiers,
                  instructions,
                  item.quantity,
                  check.service_type
                );
              }
            }

            if (instructions.length && !modifiers.length) {
              const index = prevSplits.findIndex((i) => {
                const prevInstructions = this.splitInstructions(i.instructions);
                return (
                  !i.hasOwnProperty("modifiers") &&
                  prevInstructions.length == instructions.length &&
                  this.isSameInstructions(instructions, prevInstructions)
                );
              });
              if (index != -1) {
                prevSplits[index].quantity += item.quantity;
                this.updateSplitServiceType(
                  prevSplits[index],
                  check.service_type,
                  item.quantity
                );
              } else {
                this.addInstructionsInItemSplit(
                  prevSplits,
                  instructions,
                  item.quantity,
                  check.service_type
                );
              }
            }

            return;
          }
          console.log(check.service_type, "ssssss");

          const currentService = this.getServiceInfo(
            check.service_type,
            item.quantity
          );
          result[key] = {
            id: item.menu_id,
            name: item.menu_name,
            qty: item.quantity,
            acceptedQty: 0,
            split: [],
            services: currentService
              ? [
                  {
                    name: currentService.name,
                    quantity: item.quantity,
                    icon: currentService.icon,
                    color: currentService.color
                  }
                ]
              : []
          };

          if (modifiers.length) {
            this.addModifiersInItemSplit(
              result[key].split,
              modifiers,
              instructions,
              item.quantity,
              check.service_type
            );
          }

          if (instructions.length && !modifiers.length) {
            this.addInstructionsInItemSplit(
              result[key].split,
              instructions,
              item.quantity,
              check.service_type
            );
          }

          if (!selectedItemAvailable) {
            selectedItemAvailable = item.menu_id == this.selectedItem;
          }

          if (item.status == 3) {
            result[key].acceptedQty = item.quantity;
          }
        });
      });
      if (!selectedItemAvailable) {
        this.selectedItem = null;
      }
      console.log("result22222222: ", result);
      return Object.keys(result)
        .map((i) => result[i])
        .filter(() => {
          return true;
        })
        .sort((a, b) => {
          if (a.name > b.name) return 1;
          if (a.name < b.name) return -1;
          return 0;
        });
    },
    items() {
      let result = {};
      let selectedItemAvailable = false;
      this.checks.forEach((check) => {
        check.items.forEach((item) => {
          if (item.status == 4 || item.status == 6 || item.status == 9) {
            return;
          }
          const key = "" + item.menu_id + "-" + item.serving_size_id;
          if (result.hasOwnProperty(key)) {
            result[key].qty += item.quantity;
            if (item.status == 3) {
              result[key].acceptedQty += item.quantity;
            }

            const currentService = this.getServiceInfo(
              check.service_type,
              item.quantity
            );
            const existingService = result[key].services.find(
              (s) => s.name === currentService.name
            );
            if (existingService) {
              existingService.quantity += item.quantity;
            } else {
              result[key].services.push({
                name: currentService.name,
                quantity: item.quantity,
                icon: currentService.icon,
                color: currentService.color
              });
            }

            return;
          }

          const currentService = this.getServiceInfo(
            check.service_type,
            item.quantity
          );

          result[key] = {
            id: item.menu_id,
            name: item.menu_name,
            qty: item.quantity,
            acceptedQty: 0,
            services: currentService
              ? [
                  {
                    name: currentService.name,
                    quantity: item.quantity,
                    icon: currentService.icon,
                    color: currentService.color
                  }
                ]
              : []
          };

          if (!selectedItemAvailable) {
            selectedItemAvailable = item.menu_id == this.selectedItem;
          }

          if (item.status == 3) {
            result[key].acceptedQty = item.quantity;
          }
        });
      });
      if (!selectedItemAvailable) {
        this.selectedItem = null;
      }
      return Object.keys(result)
        .map((i) => result[i])
        .filter(() => {
          return true;
        })
        .sort((a, b) => {
          if (a.name > b.name) return 1;
          if (a.name < b.name) return -1;
          return 0;
        });
    },
    mobile() {
      return this.$vuetify.breakpoint.name == "xs";
    },
    finishedItems() {
      let items = [];
      this.checks.forEach((c) => {
        c.items.forEach((i) => {
          if ([4, 6].includes(i.status)) {
            i.table_name = c.table_name;
            i.sale_open_date = c.sale_open_date;
            i.icon = c.icon;
            i.service_type = c.service_type;
            i.check_number = c.check_number;
            i.ticket_name = c.ticket_name;
            items.push(i);
          }
        });
      });

      items.sort((a, b) => {
        let d1 = Number(a.prepared_at.replace(/\D/g, ""));
        let d2 = Number(b.prepared_at.replace(/\D/g, ""));
        if (d1 < d2) return 1;
        if (d1 > d2) return -1;
        return 0;
      });

      return items;
    },
    settings() {
      return this.$store.getters.nodeSettings;
    },
    showScrollControls() {
      return this.settings.showScrollControls && this.showScrollBtn;
    },
    preference() {
      return this.$store.getters.getPreferences;
    }
  },
  mounted() {
    this.addScrollListener();
  },
  created() {
    this.getMasters();
    this.initPreference();
  },
  updated() {
    this.addScrollListener();
  }
};
</script>
